import React from 'react';
import PropTypes from 'prop-types';
import { Deserializer } from 'jsonapi-serializer';
import Raven from 'raven-js';

import ChatRooms from 'api/resources/chatRooms';
import { processErrorByAlert } from 'utils/getErrors';

import DashedButton from 'components/DashedButton';

class ChatRoomFinishButton extends React.PureComponent {
  state = { loading: false }

  componentWillUnmount() {
    if (!this.state.loading) this.finish();
  }

  handleClick = () => {
    this.finish();
  }

  async finish() {
    this.setState({ loading: true });

    try {
      const response = await ChatRooms.finish({
        chatRoomId: this.props.id,
        include: 'last_message,user,user.avatar,user.oauth_providers,user.current_ban',
      });

      const chatRoom = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);
      this.props.onFinished(chatRoom);
    } catch (err) {
      this.setState({ loading: false });
      processErrorByAlert(err);

      Raven.captureException(err, { extra: this.props });
    }
  }

  render() {
    return (
      <DashedButton
        type="button"
        disabled={this.state.loading}
        onClick={this.handleClick}
        style={{ marginLeft: '8px' }}
      >
        Завершить чат
      </DashedButton>
    );
  }
}

ChatRoomFinishButton.propTypes = {
  id: PropTypes.string,
  onFinished: PropTypes.func,
};

ChatRoomFinishButton.defaultProps = {
  id: '',
  onFinished: () => {},
};

export default ChatRoomFinishButton;
